"use client";

import { c as _c } from "react/compiler-runtime";
import { PixelGrid, pickPixelGridSeed } from "@/components/ui/pixel-grid";
import { cn } from "@/lib/utils";
import { useState } from "react";
export interface PromptIdeaPillProps {
  label: string;
  onClick: () => void;
  className?: string;
}

/**
 * Pressable pill that seeds a Caddie prompt. Each pill gets a deterministic
 * (color, pattern) pair derived from its label — the 3x3 pixel grid loops
 * only while the pill is hovered or focused.
 */
export function PromptIdeaPill(t0) {
  const $ = _c(19);
  const {
    label,
    onClick,
    className
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = pickPixelGridSeed(label);
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    pattern,
    color
  } = t1;
  const [active, setActive] = useState(false);
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setActive(true);
    t3 = () => setActive(false);
    t4 = () => setActive(true);
    t5 = () => setActive(false);
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] !== className) {
    t6 = cn("border-ds-border-default bg-ds-surface-card text-ds-text-muted hover:text-ds-text-primary hover:border-ds-neutral-300 dark:hover:border-ds-neutral-600 rounded-ds-md shadow-ds-soft inline-flex items-center gap-1.5 border px-3 py-1 text-sm font-medium leading-5 transition-colors", className);
    $[6] = className;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== active || $[9] !== color || $[10] !== pattern) {
    t7 = <PixelGrid pattern={pattern} color={color} autoplay={active} size="xs" aria-hidden="true" />;
    $[8] = active;
    $[9] = color;
    $[10] = pattern;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== label) {
    t8 = <span className="truncate">{label}</span>;
    $[12] = label;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== onClick || $[15] !== t6 || $[16] !== t7 || $[17] !== t8) {
    t9 = <button type="button" onClick={onClick} onMouseEnter={t2} onMouseLeave={t3} onFocus={t4} onBlur={t5} className={t6}>{t7}{t8}</button>;
    $[14] = onClick;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
}